import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DocumentService } from './document.service';
import { ModuleConfigService as ConfigService } from 'src/app/shared/services/config.service';


@Injectable()
export class Doc360DocumentService extends DocumentService {
  private apiUrl: string;
  private endPoint = 'documents';

  constructor(private httpClient: HttpClient,
    private configService: ConfigService
  ) {
    super();
    this.apiUrl = configService.rimApiUrl + configService.rimEndPoint;
  }

  public getUrl(fileLocationNumber: string): Observable<string> {
    return this.httpClient.get(`${this.apiUrl}/${this.endPoint}/${fileLocationNumber}`,
      { responseType: 'text' });
  }
}
